export default __webpack_public_path__ + "static/media/close-pop-gray.77466f8a.svg";